
  <!-- INDICE -->
  <!-- <app-table-of-content [sections]="sections" (selection)="scrollIntoView($event)"></app-table-of-content> -->

  <!-- SOLICITAR INFO SEGURO MEDICO - PASO 1-->
  <div #solicitarInfoSeguro></div>
  <app-medical-insurance *ngIf="isCardVisible('contratarSeguroGetInfo')"></app-medical-insurance>
  <!-- <img [src]="getImageUrl('0539da1d-067c-4845-c711-9db70b7e9500')" alt="" class="single-cover-image"> -->

  <!-- SEGURIDAD SOCIAL EN ESPAÑA -->
  <div #sistema></div>
  <div class="card tall">
    <div>
      <h5 class="webapp-pre-title">Detalles de la seguridad social en España</h5>
      <h2 class="webapp-title-secondary">¿Cómo Funciona el Sistema de Salud en España?</h2>
      <p>España cuenta con un sistema de salud público muy eficiente, financiado por los impuestos. Aquí tienes algunos puntos clave:</p>
      <ul>
        <li>El sistema de salud público es gratuito para los residentes.</li>
        <li>Para acceder a los servicios de salud públicos, necesitas la Tarjeta Sanitaria.</li>
        <li>También hay opciones de salud privada que ofrecen servicios adicionales y tiempos de espera más cortos.</li>
      </ul>

      <div class="single-post-content justify">
          <app-smart-paragraph [text]="atencionSanitaria.longPar" [limit]="atencionSanitaria.longParLimit"></app-smart-paragraph>
      </div>
    </div>
    
  </div>

  <!-- CARD CON VIÑETAS DE EXPLICACION DE ATENCION SANITARIA -->
  <app-app-section [sectionInfo]="atencionSanitaria" *ngIf="false"></app-app-section>

  <h1 class="webapp-title">Seguro médico</h1>
  <p>Si tienes planes de viajar a Europa en el futuro cercano, es importante que tengas en cuenta la necesidad de contar con un seguro médico. Muchos viajeros pasan por alto esta consideración, pero la verdad es que contratar un seguro de viaje puede ser una de las mejores decisiones que tomes antes de emprender tu viaje. En este artículo, te explicaré los beneficios e importancia de contratar un seguro médico cuando viajas a Europa, especialmente si piensas visitar España.</p>
  <app-smart-paragraph class="item-footer" [text]="'Uno de los principales beneficios de contar con un seguro médico de viaje es que te brinda la tranquilidad y seguridad de que estarás cubierto en caso de que ocurra algún imprevisto durante tu viaje. Si bien nadie quiere pensar en tener que lidiar con un problema de salud en un país extranjero, la verdad es que los accidentes y enfermedades pueden suceder en cualquier momento y lugar. Si no tienes seguro médico, podrías terminar pagando una suma considerable por los gastos médicos y los tratamientos necesarios.'" [limit]="130"></app-smart-paragraph>
  <app-smart-paragraph class="item-footer" [text]="'Te brinda la tranquilidad y seguridad de que estarás cubierto en caso de cualquier imprevisto, te da acceso a servicios médicos de calidad, y puede cubrir otros aspectos importantes de tu viaje. No dejes que un problema de salud o cualquier otro problema arruine tu viaje, asegúrate de contar con un seguro médico de viaje antes de partir.'" [limit]="120"></app-smart-paragraph>
  
  <!-- INFO DE HOSPITALES -->
  <div class="spacer-md"></div>
  <section *ngIf="false">
    <h1 class="webapp-title">Hospitales</h1>
    <p>Información sobre hospitales en las principales ciudades de España:</p>
    <div class="city-hospitals">
      <div class="city">
        <h2 class="webapp-title-secondary">Madrid</h2>
        <ul>
          <li>Hospital Universitario La Paz</li>
          <li>Hospital Clínico San Carlos</li>
          <li>Hospital Universitario 12 de Octubre</li>
        </ul>
      </div>
      <div class="city">
        <h2 class="webapp-title-secondary">Barcelona</h2>
        <ul>
          <li>Hospital Clínic de Barcelona</li>
          <li>Hospital de la Santa Creu i Sant Pau</li>
          <li>Hospital Vall d'Hebron</li>
        </ul>
      </div>
      <div class="city">
        <h2 class="webapp-title-secondary">Valencia</h2>
        <ul>
          <li>Hospital Universitari i Politècnic La Fe</li>
          <li>Hospital Clínico Universitario de Valencia</li>
          <li>Hospital General Universitario de Valencia</li>
        </ul>
      </div>
      <div class="city">
        <h2 class="webapp-title-secondary">Sevilla</h2>
        <ul>
          <li>Hospital Universitario Virgen del Rocío</li>
          <li>Hospital Universitario Virgen Macarena</li>
          <li>Hospital Quirónsalud Sagrado Corazón</li>
        </ul>
      </div>
    </div>
  </section>
  
  <!-- EMERGENCIA -->
  <div class="card tall">
    <h2 class="webapp-title-secondary">¿Qué hacer en Caso de Emergencia?</h2>
    <p>En caso de emergencia, puedes seguir estos pasos:</p>
    <ul>
      <li>Llame al 112, el número de emergencia en España.</li>
      <li>Indique claramente la naturaleza de la emergencia y su ubicación.</li>
      <li>Si es posible, diríjase al hospital más cercano.</li>
    </ul>
  </div>

  <!-- COMO RELLENAR EL FORMULARIO -->
  <div #form></div>
  <app-section-checklist [sectionInfo]="comoRellenarFormulario" *ngIf="false"></app-section-checklist>

  <!-- COMO USAR MI SEGURO MEDICO -->
  <div #how></div>
  <app-card-article [sectionInfo]="comoUsarMiSeguro" *ngIf="false"></app-card-article>

  <!-- CENTROS MEDICOS -->
  <div #centros></div>
  <app-section-steps [sectionInfo]="centrosMedicos" *ngIf="false"></app-section-steps>

  <!-- PASOS PARA TARJETA SANITARIA -->
  <div *ngIf="false">
    <h1 class="webapp-title nomargin-bottom">Pasos para Obtener la Tarjeta Sanitaria</h1>
    <ol>
      <li>Empadronarse en el ayuntamiento de tu ciudad.</li>
      <li>Acudir a tu centro de salud más cercano con los siguientes documentos:
        <ul>
          <li>Documento de identidad (DNI, NIE o pasaporte).</li>
          <li>Certificado de empadronamiento.</li>
          <li>Contrato de trabajo o documento que acredite tu situación de estudiante.</li>
        </ul>
      </li>
      <li>Rellenar el formulario de solicitud de la Tarjeta Sanitaria.</li>
      <li>Recibirás la Tarjeta Sanitaria en tu domicilio en unas semanas.</li>
    </ol>
  </div>